import React from 'react';
import PropTypes from 'prop-types';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Container from '../../../components/UI/Container';
import SectionWrapper from './featureSection.style';
import Image from "reusecore/src/elements/Image";
import { SERVICE_FEATURES_ITEMS } from '../../../data/Saas';

const TwelveFeatures = ({
  secTitleWrapper,
  secText,
  secHeading,
  Row,
  Col,
  serviceTitleStyle,
  secDes,
}) => {
  return (
    <SectionWrapper id="service_section">
      <Container>
        <Box {...secTitleWrapper}>
          <Text {...secText} content="LE RENDEZ-VOUS AUGMENTÉ" />
          <Heading
            {...secHeading}
            content="Design, innovant, efficace."
          />
          <Text
            {...secDes}
            content="Nous repensons chaque moment du RDV, de sa préparation dans votre CRM, en passant pas l'animation avec un support digital partagé, à la gestion du follow-up,  assistée. Et grâce à PowerApps, on délivre plus vite que jamais. Concentrez-vous sur vos clients, on s'occupe du reste."
          />
        </Box>

        <Box {...Row}>
          {SERVICE_FEATURES_ITEMS.map((item, index) => (
            <Box
              {...Col}
              key={`service-item-${index}`}
              className="service_item_col"
            >
              <Box className="service_item">
                <Box className="service_icon">
                  <Image src={item.icon} alternate={item.title}  />
                </Box>
                <Heading content={item.title} {...serviceTitleStyle} />
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </SectionWrapper>
  );
};

TwelveFeatures.propTypes = {
  secTitleWrapper: PropTypes.object,
  secText: PropTypes.object,
  secHeading: PropTypes.object,
  Row: PropTypes.object,
  Col: PropTypes.object,
  serviceTitleStyle: PropTypes.object,
  secDes: PropTypes.object,
};

TwelveFeatures.defaultProps = {
  secTitleWrapper: {
    mb: ['60px', '80px'],
  },
  secText: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: '20px',
    letterSpacing: '0.15em',
    fontWeight: '700',
    color: 'primary',
    mb: '12px',
  },
  secHeading: {
    textAlign: 'center',
    fontSize: ['20px', '24px', '36px', '36px'],
    fontWeight: '700',
    color: 'headingColor',
    letterSpacing: '-0.025em',
    mb: '0',
    ml: 'auto',
    mr: 'auto',
    lineHeight: '1.12',
    width: '540px',
    maxWidth: '100%',
  },
  Row: {
    flexBox: true,
    flexWrap: 'wrap',
    justifyContent: 'center',
    ml: ['0', '-15px', '-20px', '-35px', '-35px'],
    mr: ['0', '-15px', '-20px', '-35px', '-35px'],
  },
  Col: {
    pl: ['15px', '15px', '25x', '35px', '35px'],
    pr: ['15px', '15px', '25px', '35px', '35px'],
    mb: '40px',
  },
  serviceTitleStyle: {
    fontSize: ['15px', '15px', '15px', '16px', '17px'],
    fontWeight: '600',
    color: '#343d48cc',
    mb: ['0px', '120px'],
  },
  secDes: {
    fontSize: ['14px', '15px', '16px'],
    color: '#343d48cc',
    lineHeight: '1.875',
    mt: '30px',
    ml: 'auto',
    mr: 'auto',
    width: '470px',
    maxWidth: '100%',
    textAlign: 'center',
  },
};

export default TwelveFeatures;
